import React from 'react';
import { useLocation, useNavigate, Outlet } from 'react-router-dom';
import { Layout } from '../components/Layout/Layout';
import { routesConfig } from '../routes';

const matchRoutePath = (routePath: string, currentPath: string): boolean => {
  if (routePath === currentPath) return true;
  const pattern = '^' + routePath.replace(/:[a-zA-Z0-9_]+/g, '[^/]+') + '$';
  return new RegExp(pattern).test(currentPath);
};

const Home: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();

  // Find the current route config matching the active pathname (supporting dynamic params like :id)
  const currentRoute = routesConfig.find((route) => matchRoutePath(route.path, location.pathname));
  const pageTitle = currentRoute ? currentRoute.title : 'Dashboard';

  const renderContent = () => {
    // If the matched route has a defined element component, let React Router render it
    if (currentRoute && currentRoute.element !== null) {
      return <Outlet />;
    }


    // Fallback/Premium placeholder card for pages with null element (not yet implemented)
    return (
      <div className="bg-white rounded-2xl p-12 border border-[#ECECF2] text-center shadow-sm max-w-2xl mx-auto mt-10 space-y-4">
        <div className="w-16 h-16 rounded-full bg-[#FFF8E1] text-[#F9C327] flex items-center justify-center mx-auto shadow-sm">
          <svg className="w-8 h-8" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
          </svg>
        </div>
        <h3 className="text-lg font-bold text-slate-800">
          {pageTitle} Section
        </h3>
        <p className="text-slate-500 text-xs max-w-sm mx-auto leading-relaxed">
          This module is currently connected to mock routing. In the next phase, we will connect the live database APIs to manage this component.
        </p>
        <button
          onClick={() => navigate('/dashboard/users')}
          className="px-4 py-2 bg-[#C1272D] hover:bg-[#A81E23] text-white text-xs font-bold rounded-lg cursor-pointer transition-all shadow-md shadow-[#C1272D]/10"
        >
          Back to Users Dashboard
        </button>
      </div>
    );
  };

  return (
    <Layout pageTitle={pageTitle}>
      {renderContent()}
    </Layout>
  );
};

export default Home;
